(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cal-fiche-enclos"]) return;
  try {
    
(function(){
  function tirets(piste, points, pas){
    if(!piste||!points||points.children.length) return;
    var n=piste.children.length;
    for(var i=0;i<n;i++){(function(i){
      var b=document.createElement('button'); b.className='k-dash'; b.type='button'; b.setAttribute('aria-label','Item '+(i+1));
      b.onclick=function(){piste.scrollTo({left:i*pas(),behavior:'smooth'})}; points.appendChild(b);
    })(i);}
    function sync(){var k=Math.round(piste.scrollLeft/Math.max(1,pas()));[].forEach.call(points.children,function(d,j){d.setAttribute('aria-current',j===k?'true':'false')});}
    var t; piste.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(sync,80)}); addEventListener('resize',sync); sync();
  }
  function init(){
    var tr=document.querySelector('[data-cal-track]');
    tirets(tr, document.querySelector('[data-cal-dots]'), function(){return tr.clientWidth;});
    /* video de la galerie (Fares, 17/09) : pas de lecteur, elle se lance seule quand on arrive sur sa
       vignette, tourne en boucle tant qu'on y reste, s'arrete quand on la quitte */
    if(tr){
      var lire=function(){var k=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));
        [].forEach.call(tr.children,function(sl,j){var v=sl.querySelector('video');if(!v)return;
          if(j===k){var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});}else{v.pause();}});};
      var tv;tr.addEventListener('scroll',function(){clearTimeout(tv);tv=setTimeout(lire,120);},{passive:true});lire();
    }
    var pr=document.querySelector('[data-cal-proofs]');
    tirets(pr, document.querySelector('[data-cal-proofdots]'), function(){return pr.children[0]?pr.children[0].offsetWidth+12:1;});
    /* barre d'achat : visible des que le bouton principal n'est PAS a l'ecran - au-dessus comme en dessous (18/09, Fares :
       « que le ajouter au panier soit directement accessible sans devoir descendre »). En apercu de theme, elle se pose
       au-dessus du bandeau noir de Shopify, que les visiteurs ne voient jamais. */
    var barre=document.querySelector('[data-cal-sticky]'), cta=document.querySelector('[data-cal-cta]');
    if(barre&&cta){
      var attente=false;
      var maj=function(){attente=false;var r=cta.getBoundingClientRect();var on=r.bottom<0||r.top>(window.innerHeight||0);barre.classList.toggle('k-on',on);barre.setAttribute('aria-hidden',on?'false':'true');
        var ap=document.getElementById('PBarNextFrameWrapper')||document.getElementById('preview-bar-iframe');var hb=ap?ap.offsetHeight:0;barre.style.bottom=hb?(hb-18)+'px':'';barre.style.paddingBottom=hb?'28px':'';};
      addEventListener('scroll',function(){if(!attente){attente=true;(window.requestAnimationFrame||setTimeout)(maj);}},{passive:true});
      addEventListener('resize',maj); maj();
    }else if(barre){barre.classList.add('k-on');}
    /* quantite */
    var q=document.querySelector('[data-cal-qty]');
    if(q){var inp=q.querySelector('input');var borne=function(v){var max=parseInt(inp.max,10)||99;return Math.min(max,Math.max(1,v||1));};
      q.querySelector('[data-cal-moins]').onclick=function(){inp.value=borne(parseInt(inp.value,10)-1);};
      q.querySelector('[data-cal-plus]').onclick=function(){inp.value=borne(parseInt(inp.value,10)+1);};
      inp.addEventListener('change',function(){inp.value=borne(parseInt(inp.value,10));});}
    var lien=document.querySelector('.cal-fp .k-combien'), faq=document.getElementById('faq-105');
    if(lien&&faq) lien.addEventListener('click',function(){faq.open=true;});
    var lienLoc=document.querySelector('.cal-fp a[href="#faq-rent"]'), faqLoc=document.getElementById('faq-rent');
    if(lienLoc&&faqLoc) lienLoc.addEventListener('click',function(){faqLoc.open=true;});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
